import objectPath from "object-path";
import { removeNulls } from "./remove-nulls";
/**
 * Wraps objectPath's coalesce to first remove null values in the object before looking for paths, given that nulls are far more common when pulling data from APIs.
 * @param obj - the object to access properties from
 * @param paths - a set of property paths to look for, in priority order
 * @returns
 */
export var coalesce = function (obj, paths) {
  return objectPath.coalesce(removeNulls(obj), paths);
};